/* Curlette theme v2 — original code, no dependencies */
(function () {
  'use strict';

  var BB = window.BB || {};
  BB.strings = BB.strings || {};
  BB.routes = BB.routes || {};
  var tiers = BB.bundleTiers || [{ qty: 1, pct: 0 }, { qty: 2, pct: 10 }, { qty: 3, pct: 15 }];
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    format = format || BB.moneyFormat || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var m = format.match(placeholder);
    var value;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }
  BB.formatMoney = formatMoney;
  function pctFor(qty) { var pct = 0; tiers.forEach(function (t) { if (qty >= t.qty) pct = t.pct; }); return pct; }
  function applyPct(cents, pct) { return cents - Math.round(cents * pct / 100); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  /* ---------- Header: menu + search ---------- */
  function initHeader() {
    var nav = $('#MobileNav');
    var toggle = $('[data-menu-toggle]');
    if (nav && toggle) {
      var open = function (v) {
        nav.classList.toggle('is-open', v);
        nav.setAttribute('aria-hidden', String(!v));
        toggle.setAttribute('aria-expanded', String(v));
        document.documentElement.classList.toggle('no-scroll', v);
        if (v) { var f = $('a, button', $('.mobile-nav__panel', nav)); if (f) f.focus(); } else { toggle.focus(); }
      };
      toggle.addEventListener('click', function () { open(true); });
      $$('[data-menu-close]', nav).forEach(function (b) { b.addEventListener('click', function () { open(false); }); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && nav.classList.contains('is-open')) open(false); });
    }
    var st = $('[data-search-toggle]');
    var bar = $('#HeaderSearch');
    if (st && bar) {
      st.addEventListener('click', function () {
        var show = bar.hidden;
        bar.hidden = !show;
        st.setAttribute('aria-expanded', String(show));
        if (show) { var i = $('input', bar); if (i) i.focus(); }
      });
    }
  }

  /* ---------- Countdown ---------- */
  function initCountdown() {
    $$('[data-countdown]').forEach(function (el) {
      var mode = el.getAttribute('data-mode');
      var endAttr = el.getAttribute('data-end');
      var fixed = mode === 'date' && endAttr ? new Date(endAttr) : null;
      var parts = {};
      ['d', 'h', 'm', 's'].forEach(function (k) { parts[k] = $('[data-cd="' + k + '"]', el); });
      function target() {
        if (fixed && !isNaN(fixed)) return fixed;
        var t = new Date(); t.setHours(24, 0, 0, 0); return t;
      }
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var diff = Math.max(0, target() - new Date());
        if (fixed && diff === 0) { var bar = el.closest('[data-countdown-bar]'); if (bar) bar.hidden = true; return; }
        var s = Math.floor(diff / 1000);
        parts.d.textContent = pad(Math.floor(s / 86400));
        parts.h.textContent = pad(Math.floor(s % 86400 / 3600));
        parts.m.textContent = pad(Math.floor(s % 3600 / 60));
        parts.s.textContent = pad(s % 60);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- Moving "Most popular" ring ---------- */
  var SVGNS = 'http://www.w3.org/2000/svg';
  function initRing(svg) {
    var label = svg.parentElement;
    var text = (svg.getAttribute('data-ring-text') || '').trim();
    if (!text) return;
    var unit = text.toUpperCase() + ' • ';
    var offset = 0, unitLen = 0, raf = null, textPath = null;
    function build() {
      var w = label.offsetWidth, h = label.offsetHeight;
      if (!w || !h) return;
      svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
      var inset = 8, r = 14;
      var x0 = inset, y0 = inset, x1 = w - inset, y1 = h - inset;
      var d = 'M' + (x0 + r) + ',' + y0 + ' H' + (x1 - r) + ' A' + r + ',' + r + ' 0 0 1 ' + x1 + ',' + (y0 + r) +
        ' V' + (y1 - r) + ' A' + r + ',' + r + ' 0 0 1 ' + (x1 - r) + ',' + y1 + ' H' + (x0 + r) +
        ' A' + r + ',' + r + ' 0 0 1 ' + x0 + ',' + (y1 - r) + ' V' + (y0 + r) + ' A' + r + ',' + r + ' 0 0 1 ' + (x0 + r) + ',' + y0 + ' Z';
      var id = 'ring-' + Math.random().toString(36).slice(2, 8);
      svg.innerHTML = '';
      var path = document.createElementNS(SVGNS, 'path');
      path.setAttribute('id', id); path.setAttribute('d', d); path.setAttribute('fill', 'none');
      svg.appendChild(path);
      var total = path.getTotalLength();
      var t = document.createElementNS(SVGNS, 'text');
      t.setAttribute('dy', '3');
      textPath = document.createElementNS(SVGNS, 'textPath');
      textPath.setAttribute('href', '#' + id);
      textPath.textContent = unit;
      t.appendChild(textPath);
      svg.appendChild(t);
      unitLen = textPath.getComputedTextLength() || 80;
      var n = Math.ceil(total / unitLen) + 2;
      textPath.textContent = new Array(n + 1).join(unit);
      offset = 0;
      textPath.setAttribute('startOffset', String(-unitLen));
    }
    function step() {
      offset = (offset + 0.35) % unitLen;
      if (textPath) textPath.setAttribute('startOffset', String(offset - unitLen));
      raf = window.requestAnimationFrame(step);
    }
    build();
    if ('ResizeObserver' in window) new ResizeObserver(function () { build(); }).observe(label);
    if (!reduceMotion) {
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting && !raf) raf = window.requestAnimationFrame(step);
            if (!en.isIntersecting && raf) { window.cancelAnimationFrame(raf); raf = null; }
          });
        }).observe(label);
      } else { raf = window.requestAnimationFrame(step); }
    }
  }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    if (!root) return null;
    var track = $('[data-gallery-track]', root);
    if (!track) return null;
    var slides = $$('.gallery__slide', track);
    var thumbs = $$('[data-gallery-thumb]', root);
    var dots = $$('.gallery__dot', root);
    var current = 0;
    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    }
    function goTo(i, smooth) {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth === false || reduceMotion ? 'auto' : 'smooth' });
      setActive(i);
    }
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        if (i !== current && i >= 0 && i < slides.length) setActive(i);
        ticking = false;
      });
    }, { passive: true });
    var prev = $('[data-gallery-prev]', root);
    var next = $('[data-gallery-next]', root);
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(Number(t.getAttribute('data-gallery-thumb'))); }); });
    track.setAttribute('tabindex', '0');
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
    });
    return { goToMedia: function (mediaId) {
      var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(mediaId); });
      if (idx > -1) goTo(idx);
    } };
  }

  /* ---------- Carousel (testimonials, scenes) ---------- */
  function initCarousel(root) {
    var track = $('[data-carousel-track]', root);
    var dotsWrap = $('[data-carousel-dots]', root);
    var items = $$(':scope > li', track);
    if (!items.length) return;
    function perView() { return Math.max(1, Math.round(track.clientWidth / items[0].offsetWidth)); }
    function pages() { return Math.max(1, items.length - perView() + 1); }
    function index() {
      var w = items[0].offsetWidth + parseFloat(getComputedStyle(track).columnGap || 16);
      return Math.min(pages() - 1, Math.round(track.scrollLeft / w));
    }
    function go(i) {
      i = Math.max(0, Math.min(pages() - 1, i));
      track.scrollTo({ left: items[i].offsetLeft - items[0].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    function renderDots() {
      var n = pages();
      var nav = $('.carousel__nav', root);
      if (nav) nav.style.visibility = n > 1 ? '' : 'hidden';
      dotsWrap.innerHTML = '';
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'carousel__dot'; b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.addEventListener('click', (function (k) { return function () { go(k); }; })(i));
        dotsWrap.appendChild(b);
      }
      sync();
    }
    function sync() {
      var i = index();
      $$('.carousel__dot', dotsWrap).forEach(function (d, n) { d.classList.toggle('is-active', n === i); d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    var prev = $('[data-carousel-prev]', root), next = $('[data-carousel-next]', root);
    if (prev) prev.addEventListener('click', function () { go(index() - 1); });
    if (next) next.addEventListener('click', function () { go(index() + 1); });
    window.addEventListener('resize', renderDots);
    renderDots();
  }

  /* ---------- Product bundle form ---------- */
  function initProduct(section) {
    var jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var variantMedia = {}, addons = {};
    try { variantMedia = JSON.parse(($('[data-variant-media]', section) || {}).textContent || '{}'); } catch (e) { variantMedia = {}; }
    try { addons = JSON.parse(($('[data-addons-json]', section) || {}).textContent || '{}'); } catch (e) { addons = {}; }
    var gallery = initGallery($('[data-gallery]', section));
    var form = $('[data-bundle-form]', section);
    var options = $$('[data-bundle-option]', section);
    var pickers = $('[data-variant-pickers]', section);
    var addBtn = $('[data-add-btn]', section);
    var addLabel = $('[data-add-label]', section);
    var errorEl = $('[data-form-error]', section);
    var totalNow = $('[data-total-now]', section);
    var totalWas = $('[data-total-was]', section);
    var totalQty = $('[data-total-qty]', section);
    var fallbackId = $('[data-fallback-id]', section);
    var fallbackQty = $('[data-fallback-qty]', section);
    var sticky = $('[data-sticky-buy]', section);
    var stickyBtn = $('[data-sticky-add]', section);
    var stickyLabel = $('[data-sticky-label]', section);
    var stickyTotal = $('[data-sticky-total]', section);
    var stickyWas = $('[data-sticky-was]', section);

    var firstAvailable = product.variants.find(function (v) { return v.available; }) || product.variants[0];
    var single = product.variants.length === 1;
    var checked = options.find(function (o) { return o.querySelector('input[type=radio]').checked; }) || options[0];
    var maxQty = options.reduce(function (m, o) { return Math.max(m, Number(o.getAttribute('data-qty'))); }, 1);
    var sel = []; for (var i = 0; i < maxQty; i++) sel.push(firstAvailable.id);
    var state = { qty: Number(checked.getAttribute('data-qty')), pct: Number(checked.getAttribute('data-pct')), selections: sel, protection: false, mystery: false };

    function variantById(id) { return product.variants.find(function (v) { return String(v.id) === String(id); }); }
    function activeVariants() { return state.selections.slice(0, state.qty).map(variantById); }
    function mysteryFree() { return !!(addons.mystery && addons.mystery.freeFrom > 0 && state.qty >= addons.mystery.freeFrom); }

    function renderPickers() {
      if (!pickers || single) return;
      var html = '';
      for (var i = 0; i < state.qty; i++) {
        var v = variantById(state.selections[i]) || firstAvailable;
        var media = variantMedia[v.id];
        var thumb = media ? media.src : (product.featured_image ? product.featured_image + (product.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '');
        html += '<div class="picker">' +
          (thumb ? '<img class="picker__thumb" src="' + esc(thumb) + '" width="56" height="56" alt="">' : '<span></span>') +
          '<label class="picker__label" for="Picker-' + i + '">' + (i + 1) + '.</label>' +
          '<select class="picker__select" id="Picker-' + i + '" data-picker="' + i + '">' +
          product.variants.map(function (o) {
            return '<option value="' + o.id + '"' + (String(o.id) === String(v.id) ? ' selected' : '') + (o.available ? '' : ' disabled') + '>' +
              esc(o.title) + ' — ' + formatMoney(o.price) + (o.available ? '' : ' (' + esc(BB.strings.soldOut || 'Sold out') + ')') + '</option>';
          }).join('') + '</select></div>';
      }
      pickers.innerHTML = html;
      $$('[data-picker]', pickers).forEach(function (s) {
        s.addEventListener('change', function () {
          state.selections[Number(s.getAttribute('data-picker'))] = Number(s.value);
          var m = variantMedia[s.value];
          if (m && gallery) gallery.goToMedia(m.id);
          renderPickers();
          update();
        });
      });
    }

    function syncAddonInputs() {
      $$('[data-addon]', section).forEach(function (cb) {
        var type = cb.getAttribute('data-addon');
        var row = cb.closest('[data-addon-row]');
        if (row && row.getAttribute('data-free') === 'true') { cb.checked = true; return; }
        cb.checked = !!state[type];
      });
    }

    function update() {
      var vs = activeVariants();
      var full = vs.reduce(function (sum, v) { return sum + v.price; }, 0);
      var bundleNow = applyPct(full, state.pct);
      var extras = 0, extrasWas = 0;
      if (addons.protection && state.protection) { extras += addons.protection.price; extrasWas += addons.protection.price; }
      if (addons.mystery) {
        if (mysteryFree()) { extrasWas += addons.mystery.price; }
        else if (state.mystery) { extras += addons.mystery.price; extrasWas += addons.mystery.price; }
      }
      var now = bundleNow + extras;
      var was = full + extrasWas;
      var allAvailable = vs.every(function (v) { return v && v.available; });

      totalNow.textContent = formatMoney(now);
      if (was > now) { totalWas.hidden = false; totalWas.textContent = formatMoney(was); } else { totalWas.hidden = true; }
      if (totalQty) totalQty.textContent = '(' + state.qty + (state.qty === 1 ? ' Curlette' : ' Curlettes') + ')';

      var base = vs[0] || firstAvailable;
      options.forEach(function (o) {
        var q = Number(o.getAttribute('data-qty'));
        var p = Number(o.getAttribute('data-pct'));
        var f = base.price * q;
        var t = $('[data-tier-total]', o); if (t) t.textContent = formatMoney(applyPct(f, p));
        var w = $('[data-tier-full]', o); if (w) w.textContent = formatMoney(f);
        var sv = $('[data-tier-saved]', o); if (sv) sv.textContent = formatMoney(f - applyPct(f, p));
        var on = q === state.qty;
        o.classList.toggle('is-selected', on);
        $$('[data-addon]', o).forEach(function (cb) { cb.tabIndex = on ? 0 : -1; });
      });
      syncAddonInputs();

      addBtn.disabled = !allAvailable;
      if (stickyBtn) stickyBtn.disabled = !allAvailable;
      addLabel.textContent = allAvailable ? (BB.strings.addToCart || 'Add to cart') : (BB.strings.soldOut || 'Sold out');
      if (stickyLabel) stickyLabel.textContent = 'Buy ' + state.qty + (state.pct ? ' · ' + state.pct + '% off' : '');
      if (stickyTotal) stickyTotal.textContent = formatMoney(now);
      if (stickyWas) { if (was > now) { stickyWas.hidden = false; stickyWas.textContent = formatMoney(was); } else stickyWas.hidden = true; }
      if (fallbackId) fallbackId.value = base.id;
      if (fallbackQty) fallbackQty.value = state.qty;
    }

    options.forEach(function (o) {
      var radio = o.querySelector('input[type=radio]');
      radio.addEventListener('change', function () {
        state.qty = Number(o.getAttribute('data-qty'));
        state.pct = Number(o.getAttribute('data-pct'));
        renderPickers();
        update();
      });
      $$('[data-addon]', o).forEach(function (cb) {
        cb.addEventListener('click', function (e) { e.stopPropagation(); });
        cb.addEventListener('change', function () {
          if (cb.disabled) return;
          state[cb.getAttribute('data-addon')] = cb.checked;
          update();
        });
      });
    });

    function setBusy(busy) {
      addBtn.classList.toggle('is-loading', busy);
      addBtn.disabled = busy;
      if (stickyBtn) stickyBtn.disabled = busy;
      addLabel.textContent = busy ? (BB.strings.adding || 'Adding…') : (BB.strings.addToCart || 'Add to cart');
    }

    function addToCart() {
      errorEl.hidden = true;
      var grouped = {};
      activeVariants().forEach(function (v) { grouped[v.id] = (grouped[v.id] || 0) + 1; });
      var items = Object.keys(grouped).map(function (id) { return { id: Number(id), quantity: grouped[id] }; });
      if (addons.protection && state.protection) items.push({ id: addons.protection.id, quantity: 1 });
      if (addons.mystery && (state.mystery || mysteryFree())) {
        var it = { id: addons.mystery.id, quantity: 1 };
        if (mysteryFree()) it.properties = { _bundle_gift: 'free' };
        items.push(it);
      }
      setBusy(true);
      return fetch((BB.routes.cartAdd || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || BB.strings.cartError);
          return data;
        });
      }).then(function () {
        return Cart.refresh().then(function () { Cart.open(addBtn); });
      }).catch(function (err) {
        errorEl.textContent = err.message || BB.strings.cartError;
        errorEl.hidden = false;
      }).finally(function () {
        setBusy(false);
        update();
      });
    }

    form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(); });
    if (stickyBtn) stickyBtn.addEventListener('click', addToCart);

    if (sticky) {
      var stickyTick = false;
      var checkSticky = function () {
        stickyTick = false;
        var show = addBtn.getBoundingClientRect().bottom < 0;
        if (sticky.classList.contains('is-visible') === show) return;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
        document.body.classList.toggle('has-sticky', show);
      };
      window.addEventListener('scroll', function () { if (!stickyTick) { stickyTick = true; window.requestAnimationFrame(checkSticky); } }, { passive: true });
      window.addEventListener('resize', checkSticky);
      checkSticky();
    }

    renderPickers();
    update();
  }

  /* ---------- Cart drawer ---------- */
  var Cart = {
    el: null, panel: null, lastFocus: null, data: null,
    init: function () {
      this.el = $('#CartDrawer');
      if (!this.el) return;
      this.panel = $('.drawer__panel', this.el);
      var self = this;
      $$('[data-cart-close]', this.el).forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });
      document.addEventListener('keydown', function (e) {
        if (!self.el.classList.contains('is-open')) return;
        if (e.key === 'Escape') self.close();
        if (e.key === 'Tab') self.trap(e);
      });
      $$('[data-cart-open]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); self.open(a); }); });
      $('[data-cart-lines]', this.el).addEventListener('click', function (e) {
        var btn = e.target.closest('[data-line-action]');
        if (!btn) return;
        self.change(btn.getAttribute('data-key'), Number(btn.getAttribute('data-qty')));
      });
      var initial = $('#CartJSON');
      if (initial) { try { this.render(JSON.parse(initial.textContent)); } catch (e) { this.refresh(); } }
    },
    trap: function (e) {
      var f = $$('a[href], button:not([disabled]), input, select, [tabindex]:not([tabindex="-1"])', this.panel).filter(function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    },
    open: function (trigger) {
      this.lastFocus = trigger || document.activeElement;
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('no-scroll');
      var p = this.panel;
      setTimeout(function () { p.focus(); }, 50);
    },
    close: function () {
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('no-scroll');
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    },
    refresh: function () {
      var self = this;
      return fetch((BB.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); return cart; });
    },
    change: function (key, qty) {
      var self = this;
      var body = this.$('[data-cart-body]');
      body.classList.add('is-busy');
      return fetch((BB.routes.cartChange || '/cart/change') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || BB.strings.cartError);
          return data;
        });
      }).then(function (cart) { self.render(cart); })
        .catch(function (err) { self.showError(err.message); })
        .finally(function () { body.classList.remove('is-busy'); });
    },
    $: function (sel) { return $(sel, this.el); },
    showError: function (msg) { var m = this.$('[data-cart-mismatch]'); m.textContent = msg || BB.strings.cartError; m.hidden = false; },
    img: function (url) { return url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=160' : ''; },
    render: function (cart) {
      this.data = cart;
      var self = this;
      var lines = this.$('[data-cart-lines]');
      var empty = this.$('[data-cart-empty]');
      var foot = this.$('[data-cart-foot]');
      $$('[data-cart-count]').forEach(function (n) {
        n.textContent = cart.item_count;
        if (n.classList.contains('cart-bubble')) n.hidden = cart.item_count === 0;
      });
      if (!cart.items.length) { lines.innerHTML = ''; empty.hidden = false; foot.hidden = true; return; }
      empty.hidden = true; foot.hidden = false;
      lines.innerHTML = cart.items.map(function (it) {
        var discounted = it.original_line_price > it.final_line_price;
        var variant = (!it.product_has_only_default_variant && it.variant_title) ? '<p class="cart-line__variant">' + esc(it.variant_title) + '</p>' : '';
        var gift = it.properties && it.properties._bundle_gift ? '<p class="cart-line__variant">' + esc(BB.strings.freeGift || 'Free with your bundle') + '</p>' : '';
        var allocs = (it.line_level_discount_allocations || []).map(function (a) {
          return '<li>' + esc(a.discount_application && a.discount_application.title || '') + ' (−' + formatMoney(a.amount) + ')</li>';
        }).join('');
        var title = esc(it.product_title);
        return '<li class="cart-line">' +
          '<a class="cart-line__media" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' + (it.image ? '<img src="' + esc(self.img(it.image)) + '" width="72" height="72" alt="" loading="lazy">' : '') + '</a>' +
          '<div class="cart-line__info">' +
            '<a class="cart-line__title" href="' + esc(it.url) + '">' + title + '</a>' + variant + gift +
            (allocs ? '<ul class="cart-line__discounts">' + allocs + '</ul>' : '') +
            '<div class="qty" role="group" aria-label="Quantity, ' + title + '">' +
              '<button type="button" class="qty__btn" data-line-action data-key="' + esc(it.key) + '" data-qty="' + (it.quantity - 1) + '" aria-label="' + esc(BB.strings.decrease || 'Decrease quantity') + '">−</button>' +
              '<span class="qty__val" aria-live="polite">' + it.quantity + '</span>' +
              '<button type="button" class="qty__btn" data-line-action data-key="' + esc(it.key) + '" data-qty="' + (it.quantity + 1) + '" aria-label="' + esc(BB.strings.increase || 'Increase quantity') + '">+</button>' +
            '</div>' +
            '<div><button type="button" class="cart-line__remove" data-line-action data-key="' + esc(it.key) + '" data-qty="0">' + esc(BB.strings.remove || 'Remove') + '</button></div>' +
          '</div>' +
          '<div class="cart-line__price">' + (discounted ? '<s>' + formatMoney(it.original_line_price) + '</s>' : '') + '<strong>' + formatMoney(it.final_line_price) + '</strong></div>' +
        '</li>';
      }).join('');

      var savingsRow = this.$('[data-cart-savings-row]');
      var totalSaved = cart.items.reduce(function (s, it) { return s + (it.original_line_price - it.final_line_price); }, 0) +
        (cart.cart_level_discount_applications || []).reduce(function (s, a) { return s + (a.total_allocated_amount || 0); }, 0);
      if (totalSaved > 0) { savingsRow.hidden = false; this.$('[data-cart-savings]').textContent = '−' + formatMoney(totalSaved); }
      else savingsRow.hidden = true;
      this.$('[data-cart-subtotal]').textContent = formatMoney(cart.total_price);
      this.checkBundle(cart);
    },
    /* Compare what the theme advertised with what Shopify actually applied */
    checkBundle: function (cart) {
      var msg = this.$('[data-cart-mismatch]');
      msg.hidden = true;
      var pid = BB.bundleProductId;
      var addonIds = [BB.addons && BB.addons.protection, BB.addons && BB.addons.mystery].filter(Boolean).map(String);
      if (!pid) {
        var ids = cart.items.filter(function (i) { return addonIds.indexOf(String(i.variant_id)) === -1; })
          .map(function (i) { return i.product_id; }).filter(function (v, i, a) { return a.indexOf(v) === i; });
        if (ids.length !== 1) return;
        pid = ids[0];
      }
      var lines = cart.items.filter(function (i) { return String(i.product_id) === String(pid); });
      var qty = lines.reduce(function (s, i) { return s + i.quantity; }, 0);
      var problems = [];
      var pct = pctFor(qty);
      if (pct) {
        var original = lines.reduce(function (s, i) { return s + i.original_line_price; }, 0);
        var expected = Math.round(original * pct / 100);
        var actual = lines.reduce(function (s, i) { return s + (i.original_line_price - i.final_line_price); }, 0) +
          (cart.cart_level_discount_applications || []).reduce(function (s, a) { return s + (a.total_allocated_amount || 0); }, 0);
        if (actual + lines.length + 1 < expected) problems.push('the ' + pct + '% bundle saving (' + formatMoney(expected) + ')');
      }
      var freeFrom = BB.addons && Number(BB.addons.mysteryFreeFrom);
      if (BB.addons && BB.addons.mystery && freeFrom > 0 && qty >= freeFrom) {
        var box = cart.items.find(function (i) { return String(i.variant_id) === String(BB.addons.mystery); });
        if (box && box.final_line_price > 0) problems.push('your free mystery box');
      }
      if (problems.length) {
        msg.textContent = 'Heads up: ' + problems.join(' and ') + ' isn’t showing in your cart total yet. ' + (BB.strings.mismatch || '');
        msg.hidden = false;
        if (window.console) console.warn('[Curlette] Offer mismatch', { qty: qty, advertisedPct: pct, problems: problems });
      }
    }
  };
  BB.Cart = Cart;

  function initToTop() {
    var b = $('[data-to-top]');
    if (!b) return;
    var t = false;
    window.addEventListener('scroll', function () {
      if (t) return; t = true;
      window.requestAnimationFrame(function () { b.classList.toggle('is-visible', window.scrollY > 900); t = false; });
    }, { passive: true });
    b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' }); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initCountdown();
    Cart.init();
    $$('[data-product-section]').forEach(initProduct);
    $$('[data-ring]').forEach(initRing);
    $$('[data-carousel]').forEach(initCarousel);
    initToTop();
  });
})();
